// AI-CONTEXT: See docs/patterns.md#hook-permission-gate

import usePermissions from "../../hooks/usePermissions"

// Route-level permission gate. Renders the page only when the current user
// holds `permission`. While permissions are still loading nothing is shown;
// once loaded, a missing permission shows a no-access notice instead of the
// page — so a hidden area can't be reached by typing its URL directly.
const RequirePermission = ({ permission, children }) => {
    const { has, ready } = usePermissions()

    if (!ready) return null
    if (has(permission)) return children

    return (
        <div className="main">
            <div className="main-container">
                <div className="page-header">
                    <h1>Geen toegang</h1>
                </div>
                <p>Je hebt geen rechten om deze pagina te bekijken. Vraag een beheerder om toegang.</p>
            </div>
        </div>
    )
}

export default RequirePermission
